/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EmbeddableCoreMessageListener/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import FilesDownloadCombinedPdf from './FilesDownloadCombinedPdf/index'
import FilesDownloadPdf from './FilesDownloadPdf/index'
import FilesEdit from './FilesEdit/index'
import FilesPrintCombinedPdf from './FilesPrintCombinedPdf/index'
import Navigation from './Navigation/index'
import No from './No/index'
import PaymentsCreateClaim from './PaymentsCreateClaim/index'
import PaymentsCreateInvoice from './PaymentsCreateInvoice/index'
import PaymentsCreatePaymentPlanForExistingInvoice from './PaymentsCreatePaymentPlanForExistingInvoice/index'
import PaymentsEditAutopay from './PaymentsEditAutopay/index'
import PaymentsPostPayment from './PaymentsPostPayment/index'
import PaymentsRequestPayment from './PaymentsRequestPayment/index'
import React from 'react'
import ServerConnectionLost from './ServerConnectionLost/index'
import SessionExpired from './SessionExpired/index'
import TreatmentRequestOverride from './TreatmentRequestOverride/index'



/** @type {import('Simple/types.js').View} */
export default function EmbeddableCoreMessageListener({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'FilesDownloadCombinedPdf'}>
<FilesDownloadCombinedPdf
  viewPath={`${viewPath}/FilesDownloadCombinedPdf`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'FilesDownloadPdf'}>
<FilesDownloadPdf
  viewPath={`${viewPath}/FilesDownloadPdf`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'FilesEdit'}>
<FilesEdit
  viewPath={`${viewPath}/FilesEdit`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'FilesPrintCombinedPdf'}>
<FilesPrintCombinedPdf
  viewPath={`${viewPath}/FilesPrintCombinedPdf`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Navigation'}>
<Navigation
  viewPath={`${viewPath}/Navigation`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'SessionExpired'}>
<SessionExpired
  viewPath={`${viewPath}/SessionExpired`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TreatmentRequestOverride'}>
<TreatmentRequestOverride
  viewPath={`${viewPath}/TreatmentRequestOverride`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PaymentsCreateInvoice'}>
<PaymentsCreateInvoice
  viewPath={`${viewPath}/PaymentsCreateInvoice`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PaymentsCreateClaim'}>
<PaymentsCreateClaim
  viewPath={`${viewPath}/PaymentsCreateClaim`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ServerConnectionLost'}>
<ServerConnectionLost
  viewPath={`${viewPath}/ServerConnectionLost`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PaymentsPostPayment'}>
<PaymentsPostPayment
  viewPath={`${viewPath}/PaymentsPostPayment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PaymentsEditAutopay'}>
<PaymentsEditAutopay
  viewPath={`${viewPath}/PaymentsEditAutopay`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PaymentsCreatePaymentPlanForExistingInvoice'}>
<PaymentsCreatePaymentPlanForExistingInvoice
  viewPath={`${viewPath}/PaymentsCreatePaymentPlanForExistingInvoice`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PaymentsRequestPayment'}>
<PaymentsRequestPayment
  viewPath={`${viewPath}/PaymentsRequestPayment`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}